import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  caption: {
    id: 'components.Copyright.caption',
    defaultMessage: 'Powered by Octopy ©2021'
  }
});